export default __webpack_public_path__ + "static/media/timezone-icon-red.5d6ba2b3.svg";